// src/components/Templates/Hero/Hero.component.tsx
import React from "react";

interface HeroProps {
    headline: string;
    text?: {
        markup: string;
    };
    image?: {
        id: string;
        url: string;
    }[];
    button?: {
        items: {
            content: {
                id: string;
                properties: {
                    label: string;
                    link: {
                        url: string | null;
                        route?: {
                            path: string;
                        };
                    }[];
                };
            };
        }[];
    };
}

const Hero: React.FC<HeroProps> = ({ headline, text, image, button }) => (
    <div>
        <h1>{headline}</h1>
        {text && <div dangerouslySetInnerHTML={{ __html: text.markup }} />}
        {image && image.map((img) => <img key={img.id} src={img.url} alt={headline} />)}
        {button &&
            button.items.map((btn) => (
                <a key={btn.content.id} href={btn.content.properties.link[0]?.route?.path}>
                    {btn.content.properties.label}
                </a>
            ))}
    </div>
);

export default Hero;
